import { render, staticRenderFns } from "./NavButtons.vue?vue&type=template&id=49d24706&"
import script from "./NavButtons.vue?vue&type=script&lang=js&"
export * from "./NavButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports